import { Directive, ElementRef, HostListener, Input, Output, EventEmitter, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[inlineEditable]',
  standalone: false
})
export class InlineEditableDirective implements AfterViewInit {
  
  private originalValue = '';
  private currentValue = '';
  private cancelling = false;
  private _editMode = false;

  @Input() clickToEdit = true;

  @Input()
  set editMode(value: boolean) {
    if (value !== this._editMode) {
      this._editMode = value;
      if (this._editMode) {
        this.startEdit();
      } else {
        this.completeEdit();
      }
    }
  }
  get editMode() {
    return this._editMode;
  }

  @Output() editModeChange = new EventEmitter<boolean>();
  @Output() valueChange = new EventEmitter<string>();

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    this.currentValue = this.elementRef.nativeElement.textContent || '';
  }

  @HostListener('click')
  onClick() {
    if (this.clickToEdit && !this._editMode) {
      this.startEdit();
    }
  }

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent) {
    event.preventDefault();
    this.completeEdit();
  }

  @HostListener('blur')
  onBlur() {
    if (!this.cancelling) {
      this.completeEdit();
    }
  }

  @HostListener('keydown.escape')
  onEscape() {
    this.cancelling = true;
    this.cancelEdit();
    this.cancelling = false;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const target = event.target as HTMLElement;
    this.currentValue = target.textContent || '';
  }

  private startEdit() {
    this.setEditModeState(true);
    this.originalValue = this.currentValue;
    this.renderer.setAttribute(this.elementRef.nativeElement, 'contenteditable', 'true');
    
    setTimeout(() => {
      const element = this.elementRef.nativeElement;
      element.focus();
      window.getSelection()?.selectAllChildren(element); // Select all text
    });
  }

  private completeEdit() {
    this.setEditModeState(false);
    this.renderer.removeAttribute(this.elementRef.nativeElement, 'contenteditable');
    this.valueChange.emit(this.currentValue);
  }

  private cancelEdit() {
    this.setEditModeState(false);
    this.renderer.removeAttribute(this.elementRef.nativeElement, 'contenteditable');
    this.currentValue = this.originalValue;
    this.renderer.setProperty(this.elementRef.nativeElement, 'textContent', this.originalValue);
  }

  private setEditModeState(value: boolean) {
    this._editMode = value;
    this.editModeChange.emit(value);
  }
}
